export var translateY50 = '_16Zip';
export var shadow = '$_2zxIa';
export var diamondBackground = 'wRX-b';